import { getPaqueteAllImagen, getReportePaquetesImagen } from "../services/servicePaquete";

const dataInicial = {
  array: [],
  exito: 0,
  busqueda: "0",
  isImagen: false,
};

const GET_PAQUETES_IMAGEN_ALL = "GET_PAQUETES_IMAGEN_ALL";
const GET_PAQUETES_IMAGEN_REPORTE = "GET_PAQUETES_IMAGEN_REPORTE"
const GET_PAQUETES_IMAGEN_CLEAR_STATE = "GET_PAQUETES_IMAGEN_CLEAR_STATE";

export default function PaquetesImagenNReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_PAQUETES_IMAGEN_REPORTE:
      return { ...state, exito: action.payload.exito }
    case GET_PAQUETES_IMAGEN_ALL:
      return { ...state, array: action.payload.array, busqueda: action.payload.busqueda, isImagen: action.payload.isImagen };
    case GET_PAQUETES_IMAGEN_CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
        busqueda: action.payload.busqueda,
      };
    default:
      return state;
  }
}
export const getPaquetesImagenAll = ({Busqueda, IsImagen}) => async (dispatch) => {
  return await getPaqueteAllImagen({Busqueda, IsImagen}).then((Response) => {
    dispatch({
      type: GET_PAQUETES_IMAGEN_ALL,
      payload: {
        array: Response,
        busqueda: Busqueda,
        isImagen: IsImagen
      }
    });
    return Response;
  }).catch((Error) =>{
    return [];
  });
}
export const getReporteExcelPaquetesImagen = ({Busqueda, IsImagen}) => async (dispatch) => {
  return await getReportePaquetesImagen({Busqueda, IsImagen}).then((Response) => {
    dispatch({
      type: GET_PAQUETES_IMAGEN_REPORTE,
      payload: {
        exito: 1
      }
    });
    return Response;
  }).catch((Error) =>{
    return Error;
  });
}
export const clearPaquetesImagenState = () => async (dispatch) => {
  dispatch({
    type: GET_PAQUETES_IMAGEN_CLEAR_STATE,
    payload: dataInicial
  });
};